import { Modal } from "../ds";

const isMac = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform);
const MOD = isMac ? "Cmd" : "Ctrl";

const GROUPS: Array<{ title: string; rows: Array<[string, string]> }> = [
  {
    title: "General",
    rows: [
      [`${MOD}+Z`, "Undo"],
      [`${MOD}+Y or ${MOD}+Shift+Z`, "Redo"],
      [`${MOD}+S`, "Save now"],
      [`${MOD}+/`, "Ask AI"],
      ["?", "Show this list"],
      [MOD, "Hold to use the report live (Try it)"],
    ],
  },
  {
    title: "Selecting",
    rows: [
      ["Click", "Select a visual"],
      ["Shift/Ctrl+Click", "Add or remove from the selection"],
      ["Drag on empty canvas", "Select everything in the box"],
      [`${MOD}+A`, "Select all"],
      ["Esc", "Clear the selection"],
    ],
  },
  {
    title: "Moving and sizing",
    rows: [
      ["Arrow keys", "Move the selection one cell"],
      ["Shift+Arrows", "Resize one cell"],
      ["Alt (while dragging)", "Turn off snapping and guides"],
      [`${MOD}+D`, "Duplicate"],
      ["Del / Backspace", "Remove (locked visuals are protected)"],
    ],
  },
  {
    title: "Stacking",
    rows: [
      [`${MOD}+]`, "Bring forward"],
      [`${MOD}+[`, "Send backward"],
      [`${MOD}+Shift+]`, "Bring to front"],
      [`${MOD}+Shift+[`, "Send to back"],
    ],
  },
  {
    title: "Visuals and layers",
    rows: [
      ["F2", "Rename the selected visual (Layers tab)"],
      [`${MOD}+Shift+C or ${MOD}+Alt+C`, "Copy format (Chrome may keep Ctrl+Shift+C for itself)"],
      [`${MOD}+Shift+V or ${MOD}+Alt+V`, "Paste format onto the selection"],
      [`${MOD}+Shift+H`, "Hide / show the selection"],
      [`${MOD}+Shift+L`, "Lock / unlock the selection"],
    ],
  },
];

/** The designer's keyboard cheat-sheet ("?" button or key). */
export function ShortcutsModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Modal open={open} onClose={onClose} title="Keyboard shortcuts" size="lg">
      <div className="st-keys">
        {GROUPS.map((g) => (
          <section key={g.title}>
            <div className="st-section__label">{g.title}</div>
            <dl>
              {g.rows.map(([k, d]) => (
                <div key={k + d} className="st-keys__row">
                  <dt>{k.split(/ or /).map((part, i) => <span key={part}>{i ? <span className="ds-faint"> or </span> : null}<kbd>{part}</kbd></span>)}</dt>
                  <dd>{d}</dd>
                </div>
              ))}
            </dl>
          </section>
        ))}
      </div>
    </Modal>
  );
}
